/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseConsumptionAnalyticsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseConsumptionOverviewDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseWaterConsumptionDTO } from '../backend/model';
/**
 * CouncilConsumptionApi - axios parameter creator
 * @export
 */
export const CouncilConsumptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption overview for a specific council
         * @param {string} councilId 
         * @param {string} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionOverview: async (councilId: string, period?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getConsumptionOverview', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/consumption/overview`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption trends for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionTrends: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getConsumptionTrends', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/consumption/trends`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the total water consumption in litres since portal activation for a specific customer.
         * @summary Get cumulative water consumption for a customer
         * @param {string} councilId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterConsumption: async (councilId: string, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getWaterConsumption', 'councilId', councilId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWaterConsumption', 'userId', userId)
            const localVarPath = `/api/council/{councilId}/consumption/water-consumption`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilConsumptionApi - functional programming interface
 * @export
 */
export const CouncilConsumptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilConsumptionApiAxiosParamCreator(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption overview for a specific council
         * @param {string} councilId 
         * @param {string} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsumptionOverview(councilId: string, period?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConsumptionOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsumptionOverview(councilId, period, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilConsumptionApi.getConsumptionOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption trends for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsumptionTrends(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConsumptionAnalyticsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsumptionTrends(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilConsumptionApi.getConsumptionTrends']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the total water consumption in litres since portal activation for a specific customer.
         * @summary Get cumulative water consumption for a customer
         * @param {string} councilId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterConsumption(councilId: string, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWaterConsumptionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterConsumption(councilId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilConsumptionApi.getWaterConsumption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilConsumptionApi - factory interface
 * @export
 */
export const CouncilConsumptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilConsumptionApiFp(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption overview for a specific council
         * @param {string} councilId 
         * @param {string} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionOverview(councilId: string, period?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConsumptionOverviewDTO> {
            return localVarFp.getConsumptionOverview(councilId, period, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption trends for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionTrends(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConsumptionAnalyticsDTO> {
            return localVarFp.getConsumptionTrends(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the total water consumption in litres since portal activation for a specific customer.
         * @summary Get cumulative water consumption for a customer
         * @param {string} councilId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterConsumption(councilId: string, userId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWaterConsumptionDTO> {
            return localVarFp.getWaterConsumption(councilId, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilConsumptionApi - object-oriented interface
 * @export
 * @class CouncilConsumptionApi
 * @extends {BaseAPI}
 */
export class CouncilConsumptionApi extends BaseAPI {
    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get consumption overview for a specific council
     * @param {string} councilId 
     * @param {string} [period] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilConsumptionApi
     */
    public getConsumptionOverview(councilId: string, period?: string, options?: RawAxiosRequestConfig) {
        return CouncilConsumptionApiFp(this.configuration).getConsumptionOverview(councilId, period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get consumption trends for a specific council
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilConsumptionApi
     */
    public getConsumptionTrends(councilId: string, options?: RawAxiosRequestConfig) {
        return CouncilConsumptionApiFp(this.configuration).getConsumptionTrends(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the total water consumption in litres since portal activation for a specific customer.
     * @summary Get cumulative water consumption for a customer
     * @param {string} councilId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilConsumptionApi
     */
    public getWaterConsumption(councilId: string, userId: number, options?: RawAxiosRequestConfig) {
        return CouncilConsumptionApiFp(this.configuration).getWaterConsumption(councilId, userId, options).then((request) => request(this.axios, this.basePath));
    }
}

